import React, { useEffect, useState } from 'react';
import {
  CButton,
  CCard,
  CRow,
  CCol,
  CCardHeader,
  CForm,
  CCardFooter,
  CFormLabel,
  CFormText,
  CFormInput,
  CBadge,
  CModal,
  CModalTitle,
  CModalBody,
  CModalHeader,
  CModalFooter,
  CImage
} from '@coreui/react';
import Moment from 'moment';
import { useLocation, useNavigate } from 'react-router-dom';
import { insert, update, remove, uploadImage } from 'src/services/AccountTransactions';
import CIcon from '@coreui/icons-react';
import { cilTrash } from '@coreui/icons';
import { getAll } from 'src/services/AccountCategories';
import { getAll as getAllCAB } from 'src/services/CashAndBanks';
import { getAll as getAllCOA } from 'src/services/ChartOfAccounts';
import Select, { components } from 'react-select';
import { Toaster } from 'src/components/Toaster';
import ls from 'local-storage';
import { FilePond, registerPlugin } from 'react-filepond';
import 'filepond/dist/filepond.min.css';
import FilePondPluginImageExifOrientation from 'filepond-plugin-image-exif-orientation';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
import FilePondPluginImageValidateSize from 'filepond-plugin-image-validate-size';
import FilePondPluginFileValidateSize from 'filepond-plugin-file-validate-size';
import FilePondPluginImageTransform from 'filepond-plugin-image-transform';
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { Button } from '@coreui/coreui';
import imageCompression from 'browser-image-compression';

function CABActions() {
  const [id, setID] = useState(0);
  // const [accountName, setAccountName] = useState([]);
  // const [code, setCode] = useState('');
  // const [bankName, setBankName] = useState('');
  // const [description, setDescription] = useState('');
  // const [initialBalance, setInitialBalance] = useState(0);
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState({});
  const [validated, setValidated] = useState(false);
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState('');
  const [color, setColor] = useState('');
  const [amount, setAmount] = useState('');
  const [notes, setNotes] = useState('');
  const [files, setFiles] = useState('');
  const [imageURL, setImageURL] = useState('');
  const [date, setDate] = useState('');
  const [selectImageModal, setSelectImageModal] = useState(false);
  const [buttonUploadDisabled, setButtonUploadDisabled] = useState(false);

  const [coaSel, setCoaSel] = useState([]);
  const [coaOpt, setCoaOpt] = useState([]);
  const [coaMasterOpt, setCoaMasterOpt] = useState([]);

  const [cabSel, setCabSel] = useState([]);
  const [cabOpt, setCabOpt] = useState([]);
  const [cabMasterOpt, setCabMasterOpt] = useState([]);
  const [startDate, setStartDate] = useState(new Date());

  const [onProcess, setOnProcess] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();

  registerPlugin(
    FilePondPluginImageExifOrientation,
    FilePondPluginImagePreview,
    FilePondPluginImageValidateSize,
    FilePondPluginFileValidateSize
  );

  async function upload() {
    setMessage('Uploading, Please Wait');
    setOpen(true);
    setColor('green');
    const options = {
      maxSizeMB: 1, // (default: Number.POSITIVE_INFINITY)
      maxWidthOrHeight: 1000 // compressedFile will scale down by ratio to a point that width or height is smaller than maxWidthOrHeight (default: undefined)
    };

    setButtonUploadDisabled(true);

    const compressedFile = await imageCompression(files[0].file, options);
    let momentDate = Moment(new Date()).format('YYYYMMDD-HHmmss');

    const response = await uploadImage(compressedFile, `accTrx/`, id, momentDate);

    if (response.data.success === 1) {
      setImageURL(response.data.resUrl);
      setButtonUploadDisabled(false);
      setSelectImageModal(false);
      setMessage(response?.data.message);
      setOpen(true);
      setColor('green');
    } else {
      setMessage(response?.data.message);
      setOpen(true);
      setButtonUploadDisabled(false);
      setSelectImageModal(false);
    }

    // .then(
    //   ({ status, url }) => {
    //     if (status === 200) {
    //       urlsTemp = url;
    //     } else {
    //       addToast("upload error!", 400);
    //     }
    //   }
    // );
  }

  async function fetchCategories() {
    let options = [];
    await getAll().then((response) => {
      options = response.cashAndBanks.map((item) => {
        return { label: item.name, value: item.id };
      });
      setCategories(options);
    });
    if (location.state) {
      let dataSelected = options.filter((item) => item.value === location.state.categoryID);
      setSelectedCategory(dataSelected[0]);
    }
  }

  async function fetchCOA() {
    let data = [];
    const response = await getAllCOA();

    data = response.coa.map((item) => {
      return { ...item, value: item.id, label: item.code + ' - ' + item.name };
    });

    setCoaMasterOpt(data);
    setCoaOpt(data);
    if (location.state) {
      let dataSelected = data.filter((item) => item.value === location.state.coaID);
      setCoaSel(dataSelected[0]);
    }
  }

  async function fetchCAB() {
    let data = [];
    const response = await getAllCAB();

    data = response.cashAndBanks.map((item) => {
      return { ...item, value: item.id, label: item.name };
    });

    setCabMasterOpt(data);
    setCabOpt(data);
    if (location.state) {
      let dataSelected = data.filter((item) => item.value === location.state.cabID);
      setCabSel(dataSelected[0]);
    }
  }

  useEffect(() => {
    fetchCOA();
    fetchCAB();
    fetchCategories();
    if (location.state) {
      setID(location.state.id);
      setAmount(location.state.amount);
      setNotes(location.state.notes ?? '');
      setImageURL(location.state.imageURL ?? '');
    }
  }, [location]);

  async function deleteTrx() {
    await remove(id).then((response) => {
      if ((response?.data?.success ?? 0) == 1) {
        setMessage(response?.data?.message);
        setOpen(true);
        const data = () =>
          setTimeout(() => {
            navigate(-1);
          }, 2000);

        data();

        return clearTimeout(data);
      }
    });
  }

  async function handleSubmit(e) {
    const form = e.currentTarget;

    e.preventDefault();
    e.stopPropagation();

    // if (form.checkValidity() === false) {
    //   console.log("hit this")
    // } else {
      let data = {
        id: id,
        categoryID: selectedCategory.value,
        bankID: cabSel.value,
        coaID: coaSel.value,
        amount: amount,
        notes: notes,
        date: date,
        imageURL
      };

      if((parseInt(data.categoryID) === 2 && !imageURL) || !data.coaID || !data.bankID || !data.amount  ){
        setValidated(false);
        let message = ``
        let count = 0
        if(parseInt(data.categoryID) === 2 && !imageURL){
          message = 'Account Category Expense Requires an Image As Reliable Documentation'
        } else {
          if(!data.coaID){
            message = 'Account'
            count += 1
          } 
          
          if (!data.bankID) {
            message = `${count === 0 ? '' : `${message}`}${count === 0 ? '' : ', '}Cash And Bank`
            count += 1
          } 
          
          if (!data.amount) {
            message = `${count === 0 ? '' : `${message}`}${count === 0 ? '' : ', '}Amount`
            count += 1
          } 
          
          message = `${message} ${count > 1 ? "are" : "is"} required field${count > 1 ? "s" : ""}`
          setMessage(message)
          setOpen(true)
        }

        setMessage(message)
        setOpen(true)
        setColor("red")
      } else {
        if (location.state) {
          await update(data).then((response) => {
            if ((response?.data?.success ?? 0) == 1) {
              setMessage(response?.data?.message)
              setOpen(true)
              const data = () =>
              setTimeout(() => {
                navigate(-1);
              }, 2000);
      
              data();
      
              return clearTimeout(data);
            } else {
              setMessage(response?.data?.message)
              setOpen(true)
              setColor("red")
            }
          });
        } else {
          await insert(data).then((response) => {
            if ((response?.data?.success ?? 0) == 1) {
              setMessage(response?.data?.message)
              setOpen(true)
              const data = () =>
              setTimeout(() => {
                navigate(-1);
              }, 2000);
      
              data();
      
              return clearTimeout(data);
            } else {
              setMessage(response?.data?.message)
              setOpen(true)
              setColor("red")
            }
          });
        }
      // }
    }


    // e.preventDefault()
    // console.log('bener')
  }
  return (
    <CCard>
      <Toaster open={open} message={message} setOpen={setOpen} ahd={1500} color={color ?? 'red'} />
      <CModal visible={selectImageModal} onClose={() => setSelectImageModal(false)} size="md">
        <CModalHeader closeButton>
          <CModalTitle>Upload Foto</CModalTitle>
        </CModalHeader>
        <CModalBody>
          <FilePond
            instantUpload={false}
            files={files}
            onupdatefiles={setFiles}
            allowMultiple={false}
            maxFiles={1}
            allowFileSizeValidation={true}
            // maxFileSize='1MB'
            labelMaxFileSizeExceeded="File is too large"
            imageTransformOutputQuality={30}
            // server="/api"
            name="files"
            labelIdle='Drag & Drop file atau <span class="filepond--label-action">Browse</span>'
          />
        </CModalBody>
        <CModalFooter>
          <CButton disabled={buttonUploadDisabled} onClick={() => upload()}>
            Upload
          </CButton>
        </CModalFooter>
      </CModal>

      <CCardHeader>Actions - Transactions</CCardHeader>
      <CForm onSubmit={(e) => handleSubmit(e)} noValidate validated={validated}>
        <div style={{ margin: '16px' }}>
          <CRow className="mb-3">
            <CCol md={2}>
              <CFormLabel>Account</CFormLabel>&nbsp;
              <CBadge color="warning">Required</CBadge>
            </CCol>
            <CCol>
              <Select
                options={coaOpt}
                value={coaSel}
                onChange={(e) => {
                  setCoaSel(e);
                  let filtered = categories.filter((item) => {
                    return item.value === e.category_id;
                  });
                  console.log(filtered);
                  setSelectedCategory(filtered[0] ?? []);
                }}
              />
            </CCol>
          </CRow>
          <CRow className="mb-3">
            <CCol md={2}>
              <CFormLabel>Category</CFormLabel>&nbsp;
              {/* <CBadge color="warning">Required</CBadge> */}
            </CCol>
            <CCol>
              <Select isDisabled={true} options={categories} value={selectedCategory} />
            </CCol>
          </CRow>
          <CRow className="mb-3">
            <CCol md={2}>
              <CFormLabel>Cash And Bank</CFormLabel>&nbsp;
              <CBadge color="warning">Required</CBadge>
            </CCol>
            <CCol>
              <Select
                // isDisabled={true}
                options={cabOpt}
                value={cabSel}
                onChange={(e) => {
                  setCabSel(e);
                }}
                required
              />
            </CCol>
          </CRow>
          <CRow className="mb-3">
            <CCol md={2}>
              <CFormLabel>Amount</CFormLabel>&nbsp;
              <CBadge color="warning">Required</CBadge>
            </CCol>
            <CCol>
              <CFormInput
                type="number"
                value={amount}
                onChange={(e) => {
                  console.log(e.target.value);
                  setAmount(e.target.value);
                }}
                feedbackInvalid="Required value"
                required
              />
            </CCol>
          </CRow>
          <CRow className="mb-3">
            <CCol md={2}>
              <CFormLabel>Notes</CFormLabel>&nbsp;
            </CCol>
            <CCol>
              <CFormInput type="text" value={notes} onChange={(e) => setNotes(e.target.value)} />
            </CCol>
          </CRow>
          <CRow className="mb-3">
            <CCol md={2}>
              <CFormLabel>Date</CFormLabel>&nbsp;
              <CBadge color="warning">Required</CBadge>
            </CCol>
            <CCol>
              <DatePicker
                selected={startDate}
                onChange={(date) => {
                  setStartDate(date);

                  let momentDate = Moment(date).format('YYYY-MM-DD HH:mm:ss');

                  setDate(momentDate);
                }}
              />
            </CCol>
          </CRow>
          <CRow className="mb-3">
            <CCol md={2}>
              <CFormLabel>Image</CFormLabel>&nbsp;
              {/* <CBadge color="warning">Required</CBadge> */}
            </CCol>
            <CCol>
              <CButton
                // feedbackInvalid= {parseInt(selectedCategory.value) === 1}
                onClick={(e)=>{
                  setSelectImageModal(true)}}
              >
                {
                  imageURL.includes("https://ik.imagekit.io/sukhakala/") || imageURL.includes("https://ik.imagekit.io/sukhakala2/")  ? 
                  "Change Image" :
                  "Upload Image"
                }
            </CButton>
            </CCol>
          </CRow>
          {
            imageURL.includes("https://ik.imagekit.io/sukhakala/") || imageURL.includes("https://ik.imagekit.io/sukhakala2/")  ? (
            <CRow className="mb-3">
              <CCol md={2}></CCol>
              <CCol>
                <CImage src={imageURL} alt={`AccTrx-${id}`} />
              </CCol>
            </CRow>
          ) : (
            <></>
          )}
        </div>
        <CCardFooter style={{ textAlign: 'right' }}>
          {location.state ? (
            <CButton
              color="danger"
              onClick={() => {
                deleteTrx();
              }}
            >
              <CIcon icon={cilTrash} />
            </CButton>
          ) : (
            <div></div>
          )}
          &emsp;
          <CButton
            style={{
              color: 'black',
              backgroundColor: 'white'
            }}
            onClick={() => {
              navigate(-1);
            }}
          >
            Cancel
          </CButton>
          &emsp;
          <CButton
            color="success"
            style={{
              color: 'white'
            }}
            type="submit"
          >
            Save
          </CButton >
        </CCardFooter>
      </CForm>
    </CCard>
  );
}

export default CABActions;
